import { Empty, Pagination } from "antd";
import LoadingSpinner from "components/LoadingSpinner";
import RangeDateFilter from "components/RangeDateFilter";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { getWorldNews } from "../api";
import NewsCard from "./NewsCard";

// AQ-290: период по умолчанию "за 23-26" (2023-2026).
const DEFAULT_RANGE = { from: "2023-01-01", to: "2026-12-31" };
const PAGE_SIZE = 12;

// worldnews требует даты в формате "YYYY-MM-DD HH:mm:ss" (с пробелом).
const buildParams = ({ from, to, page }) =>
  [
    `from=${encodeURIComponent(`${from} 00:00:00`)}`,
    `to=${encodeURIComponent(`${to} 23:59:59`)}`,
    `page=${page}`,
    `size=${PAGE_SIZE}`,
  ].join("&");

export default function WorldNews() {
  const [range, setRange] = useState(DEFAULT_RANGE);
  const [page, setPage] = useState(0);
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    setLoading(true);
    getWorldNews(buildParams({ ...range, page })).then((data) => {
      if (!active) return;
      setItems(data?.content || []);
      setTotal(data?.totalElements || 0);
      setLoading(false);
    });
    return () => {
      active = false;
    };
  }, [range, page]);

  const handleChangeDate = ([from, to]) => {
    setPage(0);
    setRange({
      from: from.format("YYYY-MM-DD"),
      to: to.format("YYYY-MM-DD"),
    });
  };

  return (
    <div className="worldnews mb20">
      <div className="worldnews__head">
        <h3>Лента СМИ</h3>
        <RangeDateFilter
          startDate={range.from}
          endDate={range.to}
          value={[moment(range.from), moment(range.to)]}
          setRange={handleChangeDate}
        />
      </div>

      <LoadingSpinner loading={loading}>
        {items.length > 0 ? (
          <>
            <div className="worldnews__grid">
              {items.map((item) => (
                <NewsCard key={item.id} {...item} />
              ))}
            </div>
            <div className="worldnews__pagination">
              <Pagination
                current={page + 1}
                pageSize={PAGE_SIZE}
                total={total}
                showSizeChanger={false}
                onChange={(p) => setPage(p - 1)}
              />
            </div>
          </>
        ) : (
          <Empty description="Нет публикаций за выбранный период" />
        )}
      </LoadingSpinner>
    </div>
  );
}
